// External libraries
import { identity, size } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import noop from 'lodash/noop';

// Zocdoc dependencies
import {
    getUser,
    getUserSuccess,
} from '@zocdoc-frontend-common/state-user-account/actions/user';
import { userSelector } from '@zocdoc-frontend-common/state-user-account/selectors';

// This package
import { default as BaseHeader, primitives } from './Header';
import { createReduxStore } from './store';

export const store = createReduxStore();

// The identity function actually does something! Don't remove it.
const ConnectedHeader = connect(identity)(BaseHeader);

class HeaderContainer extends PureComponent {
    static propTypes = {
        onGetUser: PropTypes.func,
        /**
         * pass a predetermined user API response for testing purposes
         */
        user: PropTypes.object,

        store: PropTypes.object,
    };

    static defaultProps = {
        onGetUser: noop,
        store,
    };

    componentDidMount() {
        if (this.props.user) {
            this.props.store.dispatch(getUserSuccess(this.props.user));
            this.props.onGetUser(this.props.user);
        } else {
            this.maybeGetUser();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('load', this.getUser);
    }

    render() {
        return <ConnectedHeader {...this.props} />;
    }

    getUser = async () => {
        try {
            const user = await this.props.store.dispatch(getUser());
            this.props.onGetUser(user);
        } catch (e) {
            // do nothing
        }
    };

    maybeGetUser() {
        const state = this.props.store.getState();

        if (this.props.theme.allowSignIn && size(userSelector(state)) === 0) {
            if (document.readyState === 'complete') {
                this.getUser();
            } else {
                window.addEventListener('load', this.getUser);
            }
        }
    }
}

const Header = withTheme(HeaderContainer);

export default Header;

export { primitives, Header };
